<script>
import Vue from "vue";
import VTooltip from "v-tooltip";
Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import "v-tooltip/dist/v-tooltip.css";
import Loader from "@/components/widgets/loader";

export default {
    mixins: [Api, Sabit],
    props: ["DonemId", "BirimId", "IcKontrolDonemId", "Birimler", "RevizeDonemler"],
    components: {
        Loader
    },
    data() {
        return {
            Page: {
                PageNumber: "1",
                PageSize: "9999",
                PageDataSize: "1",
            },
            TableData: {},
            BirimAdi: "",
            RevizeDonemi: "",
            loading: true,
            uri: "data:application/vnd.ms-excel;base64,",
            template: '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
            base64: function (s) {
                return window.btoa(unescape(encodeURIComponent(s)));
            },
            format: function (s, c) {
                return s.replace(/{(\w+)}/g, function (m, p) {
                    return c[p];
                });
            },
        };
    },
    watch: {
        DonemId() {
            this.Get();
        },
    },
    methods: {
        Get() {
            let Filter = "&DonemId=" + this.DonemId + "&BirimId=" + this.BirimId;
            this.ActionsFilterGet({ Service: "StrKontrolGiris/GetSoruFormu", Page: this.Page, Filter: Filter }).then((res) => {
                this.TableData = res.Data;
                this.Page.PageDataSize = res.TotalCount;


            });
            for (var Birim in this.Birimler) {
                if (this.Birimler[Birim].Id == this.BirimId) {
                    this.BirimAdi = this.Birimler[Birim].BirimAdi
                }
            }
            for (var RevizeDonemi in this.RevizeDonemler) {
                if (this.RevizeDonemler[RevizeDonemi].Id == this.IcKontrolDonemId) {
                    this.RevizeDonemi = this.RevizeDonemler[RevizeDonemi].Aciklama
                }
            }



        },
        ExcelExport(table, name) {
            if (!table.nodeType) table = this.$refs.veriGiris;
            var html = table.innerHTML
            var ctx = { worksheet: name || 'Worksheet', table: html }
            var a = document.createElement('a');
            a.href = this.uri + this.base64(this.format(this.template, ctx));
            a.download = name + '.xls';
            a.click();
        },
        giris(Data){
            var Deger = 0;
            for(var i = 0; i < Data.length; i++){
                if(Data[i].DonemId == this.IcKontrolDonemId){

                        Deger += Data[i].Deger;
    
                }
            }
            return Deger.toFixed(0)

        }
    },
    computed: {},
    created() {
        this.Get();
    },
};
</script>
<template>
    <Loader :loading="loading">
        <div>
            <div class="text-sm-end">
                <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="
                    ExcelExport(
                        'Soru Formu Sonuçları (Birim Bazlı)',
                        'Soru Formu Sonuçları (Birim Bazlı)',
                    )
                ">
                    <i class="mdi mdi-file-export-outline me-1"></i>
                    Excel'e Aktar
                </button>
            </div>
            <div ref="veriGiris" class="table-responsive">
                <div class="table-responsive">
                    <table class="table table-borderless mb-0" style="border-collapse: collapse; width: 100%">
                        <tr>
                            <td colspan="8" class="h5" style="text-align: center;border-color: #0049B7; border-style: solid; font-family: Arial; display: block;">
                               Soru Formu Sonuçları (Birim Bazlı) <br> {{ BirimAdi }}
                            </td>
                        </tr>
                    </table>
                    <br>
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="table-responsive" v-for="(TableDataVerileri, index) in TableData"
                                    :key="index">
                                    <table class="table table-striped table-bordered mb-0">
                                        <thead >
                                            <tr style="background-color: #0049B7;">
                                                <th colspan="8">{{ TableDataVerileri.AnaGrupValue }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                  
                                                <table class="table table-striped table-bordered mb-0">
                                                    <thead v-for="(GirisVerileri, index) in TableDataVerileri.EylemDetay[0].Giris"
                                                                :key="index">
                                                        <tr v-if="GirisVerileri.DonemId == IcKontrolDonemId" style="background-color: #d0bdf4;">
                                                            <th colspan="4">{{ TableDataVerileri.StandartGenelSarti }}</th>
                                                            <th colspan="4">
                                                             {{ GirisVerileri.DonemAdi }}
                                                                <br />
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody v-for="(AltTableDataVerileri, index) in TableDataVerileri.EylemDetay"
                                                            :key="index">
                                                        <tr>
                                                                        <td colspan="4">{{ AltTableDataVerileri.Eylem.Eylem}}</td>
                                                                        <td colspan="4">{{ giris(AltTableDataVerileri.Giris) }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                     
                                        </tbody>
                                    </table>
                                    <br /><br />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </Loader>
</template>
